// extracted by mini-css-extract-plugin
export default {"helpArticle":"Gccdc36"};